var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewIndex"},[_c('div',[_c('ht-runtime-template',{attrs:{"sqlAlias":_vm.sqlAlias,"alias":_vm.alias,"single":_vm.single,"queryView":_vm.queryView}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }